<template>
  <div>
    <AutoCompleteSelect
      :value="value"
      :store="store"
      :multiple="false"
      @selectChanged="selectChanged"
      @operatorChanged="operatorChanged"
      :operators="['some', 'not_some', 'every', 'not_every']"
      :placeholder="$t('role.text')"
    />
  </div>
</template>

<script>
import AutoCompleteSelect from "./AutoCompleteSelect";
import { methods } from "./commons";

export default {
  props: ["value"],

  components: { AutoCompleteSelect },
  data() {
    return { store: "role" };
  },
  methods,
};
</script>
